import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Checkbox } from "@/components/ui/checkbox";

const OBIETTIVI_VITA = [
  "Protezione della famiglia", "Copertura mutuo", "Pensione integrativa",
  "Risparmio a lungo termine", "Protezione reddito"
];

export function VitaStep0({ formData, update }) {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-sm text-[#0F1F14]">Età</Label>
          <Input type="number" value={formData.eta || ""} onChange={e => update("eta", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="35" data-testid="eta-input" />
        </div>
        <div className="space-y-2">
          <Label className="text-sm text-[#0F1F14]">Stato civile</Label>
          <Select value={formData.stato_civile || ""} onValueChange={v => update("stato_civile", v)}>
            <SelectTrigger className="rounded-xl border-[#E5E2DB] h-11" data-testid="stato-civile-select"><SelectValue placeholder="Seleziona" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="celibe_nubile">Celibe/Nubile</SelectItem>
              <SelectItem value="coniugato">Coniugato/a</SelectItem>
              <SelectItem value="convivente">Convivente</SelectItem>
              <SelectItem value="divorziato">Divorziato/a</SelectItem>
              <SelectItem value="vedovo">Vedovo/a</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-sm text-[#0F1F14]">Numero figli</Label>
          <Input type="number" value={formData.numero_figli || ""} onChange={e => update("numero_figli", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="0" data-testid="figli-input" />
        </div>
        <div className="space-y-2">
          <Label className="text-sm text-[#0F1F14]">Professione</Label>
          <Input value={formData.professione || ""} onChange={e => update("professione", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="es. Impiegato" data-testid="professione-input" />
        </div>
      </div>
      <div className="space-y-2">
        <Label className="text-sm text-[#0F1F14]">Reddito annuo indicativo</Label>
        <Select value={formData.reddito_annuo || ""} onValueChange={v => update("reddito_annuo", v)}>
          <SelectTrigger className="rounded-xl border-[#E5E2DB] h-11" data-testid="reddito-select"><SelectValue placeholder="Seleziona fascia" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="sotto_25k">Sotto 25.000 €</SelectItem>
            <SelectItem value="25k_50k">25.000 - 50.000 €</SelectItem>
            <SelectItem value="50k_100k">50.000 - 100.000 €</SelectItem>
            <SelectItem value="sopra_100k">Sopra 100.000 €</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export function VitaStep1({ formData, update, toggleArray }) {
  return (
    <div className="space-y-5">
      <p className="text-sm text-[#4A5E51]">Quali sono i tuoi obiettivi principali?</p>
      <div className="space-y-3">
        {OBIETTIVI_VITA.map(o => (
          <label key={o} className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${(formData.obiettivi || []).includes(o) ? 'border-[#163321] bg-[#163321]/5' : 'border-[#E5E2DB] hover:bg-[#F5F4F0]'}`} data-testid={`obiettivo-${o.replace(/\s/g, '-').toLowerCase()}`}>
            <Checkbox checked={(formData.obiettivi || []).includes(o)} onCheckedChange={() => toggleArray("obiettivi", o)} className="data-[state=checked]:bg-[#163321]" />
            <span className="text-sm text-[#0F1F14]">{o}</span>
          </label>
        ))}
      </div>
      <div className="space-y-2">
        <Label className="text-sm text-[#0F1F14]">Hai un mutuo in corso?</Label>
        <RadioGroup value={formData.ha_mutuo || ""} onValueChange={v => update("ha_mutuo", v)} className="flex gap-4">
          <div className="flex items-center gap-2"><RadioGroupItem value="si" id="mutuo-si" data-testid="mutuo-si" /><Label htmlFor="mutuo-si" className="text-sm">Sì</Label></div>
          <div className="flex items-center gap-2"><RadioGroupItem value="no" id="mutuo-no" data-testid="mutuo-no" /><Label htmlFor="mutuo-no" className="text-sm">No</Label></div>
        </RadioGroup>
      </div>
    </div>
  );
}

export function renderVitaStep(step, formData, update, toggleArray) {
  if (step === 0) return <VitaStep0 formData={formData} update={update} />;
  if (step === 1) return <VitaStep1 formData={formData} update={update} toggleArray={toggleArray} />;
  return null;
}
